<template>
    <div>
        <h1 class="title text-center">Click to add</h1>
        <image-layer v-for="(layer, index) in imageLayers"
                     :key="layer.type + 'index - available'"
                     :availableLayer="true"
                     :layer="layer"
                     :idx="index"
                     @addLayer="$emit('addLayer', layer)"/>
    </div>
</template>

<script type="text/babel">
import LayersMixin from '@/mixins/LayersMixin.vue';

import Modal from '../../../../../../Shared/Modal/FunctionalModal.vue';
export default {
    name: 'ImagesCategory',
    data () {
        return {};
    },
    props: {
        availableLayers: {
            type: Array
        }
    },
    computed: {
        imageLayers () {
            return this.availableLayers.filter(layer => layer.type === 'image');
        }
    },
    components: {
        Modal
    },
    mixins: [LayersMixin]
};

</script>

<style lang="scss" scoped>
    .title {
        color: white;
    }

    .text-center {
        text-align: center;
    }
</style>
